module.exports = __webpack_public_path__ + "static/media/header.6fe7cc5d.png";